"use client";

import { INavigationLink } from "@faire/retailer-visitor-shared/components/Header/desktop/NavigationLinksBar/__internal__/INavigationLink";
import { useNavigationQuery } from "@faire/retailer-visitor-shared/stores/domain/useNavigationQuery";
import { ClientPlatformType } from "@faire/web-api--source/indigofair/data/ClientPlatformType";
import { INavigationLink as INavigationLinkData } from "@faire/web-api--source/indigofair/data/INavigationLink";
import { IQueryFlashSalesRequest } from "@faire/web-api--source/indigofair/data/IQueryFlashSalesRequest";
import { useMemo } from "react";

import { NavigationLinksBar } from "./NavigationLinksBar";

export const LoggedOutNavigationLinksBar: React.FC = () => {
  const { navigationLinkGroup } = useNavigationQuery(
    ClientPlatformType.CLIENT_DESKTOP
  );

  const allDesktopC1Links = useMemo(() => {
    return navigationLinkGroup.flatMap((group) => group.navigation_links);
  }, [navigationLinkGroup]);

  const visibleLinks: INavigationLink[] = useMemo(
    () =>
      allDesktopC1Links
        .filter(
          (link) =>
            link.style_group !== INavigationLinkData.StyleGroup.INVISIBLE &&
            link.style_group !==
              INavigationLinkData.StyleGroup.INVISIBLE_FOR_ASSIGNMENT
        )
        .map(
          ({
            name,
            deep_link_path,
            path_identifier,
            unique_identifier,
            sublinks,
            sale_source,
          }) => ({
            name: name ?? "",
            to: deep_link_path,
            hasSublinks: sublinks.length > 0,
            categoryPathIdentifier: path_identifier,
            uniqueIdentifier: unique_identifier,
            isWarehouseSale:
              sale_source ===
              IQueryFlashSalesRequest.SearchSource.SEASONAL_SALE,
          })
        ),
    [allDesktopC1Links]
  );

  return (
    <NavigationLinksBar
      nextPrefetchCategoryC1Route={() => {}}
      visibleLinks={visibleLinks}
    />
  );
};
